<template>
	<div>
		<h1>404, not found from outside</h1>
	</div>
</template>
<script>
export default {
	name: "not-found-url",
	components: {},
};
</script>
